export const getDateRange = (range, customStartDate = null, customEndDate = null) => {
    const todayDate = new Date();
    let start = new Date();
    let end = new Date();

    const normalizedRange = String(range || '').trim().toLowerCase();

    switch (normalizedRange) {
        case "today":
            start = new Date();
            end = new Date();
            break;
        case "yesterday":
            const y = new Date();
            y.setDate(y.getDate() - 1);
            start = end = y;
            break;
        case "weekly":
        case "current week":
        case "last 7 days":
        case "last7days":
            start = new Date();
            start.setDate(todayDate.getDate() - 6);
            end = new Date();
            break;
        case "monthly":
        case "current month":
        case "currentmonth":
            start = new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
            end = new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0);
            break;
        case "last month":
            start = new Date(todayDate.getFullYear(), todayDate.getMonth() - 1, 1);
            end = new Date(todayDate.getFullYear(), todayDate.getMonth(), 0);
            break;
        case "yearly":
        case "current year":
        case "current fy":
        case "currentfy":
            start = new Date(todayDate.getMonth() < 3 ? todayDate.getFullYear() - 1 : todayDate.getFullYear(), 3, 1);
            end = new Date(todayDate.getMonth() < 3 ? todayDate.getFullYear() : todayDate.getFullYear() + 1, 2, 31);
            break;
        case "previous fy":
            start = new Date(todayDate.getMonth() < 3 ? todayDate.getFullYear() - 2 : todayDate.getFullYear() - 1, 3, 1);
            end = new Date(todayDate.getMonth() < 3 ? todayDate.getFullYear() - 1 : todayDate.getFullYear(), 2, 31);
            break;
        case "custom":
            if (customStartDate && customEndDate) {
                const parseDate = (dStr) => {
                    if (typeof dStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dStr)) {
                        return new Date(`${dStr}T00:00:00`);
                    }
                    return new Date(dStr);
                };
                start = parseDate(customStartDate);
                end = parseDate(customEndDate);
            }
            break;
        default:
            start = end = todayDate;
    }

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return {
        startDate: formatDate(start),
        endDate: formatDate(end),
    };
};
